import { isProdEnvironment } from '../../../interfaces/environment/Environment';
import { getWindow } from '../../../services/windowService';
import { ConfiguratorContextState } from './ConfiguratorContext';
import { Action, Actions } from './configuratorActions';

const wnd = getWindow();

export const configuratorReducer = (
  currentState: ConfiguratorContextState,
  action: Action,
): ConfiguratorContextState => {
  let state = currentState;
  switch (action.type) {
    case Actions.SET_CONFIGURATION_DATA:
      state = {
        ...state,
        configurationData: action.payload,
      };
      break;
    case Actions.MERGE_ARTICLE_DEFINITIONS:
      const articleDefinitions = Object.fromEntries(
        Object.entries(state.articleDefinitions)
          .map(([key, value]) => [key, { ...value }])
          .concat(action.payload.map((article) => [article.number, article])),
      );
      state = {
        ...state,
        articleDefinitions,
      };
      break;
    case Actions.SET_CURRENT_CONFIGURATION:
      state = {
        ...state,
        currentConfiguration: action.payload,
      };
      break;
    case Actions.SET_CURRENT_REQUEST_INFO:
      state = {
        ...state,
        currentRequestInfo: action.payload,
      };
      break;
    case Actions.SET_CURRENT_PROJECT:
      state = {
        ...state,
        currentProject: action.payload,
      };
      break;
    case Actions.SET_CURRENT_CONFIGURATIONS:
      state = {
        ...state,
        currentConfigurations: action.payload,
      };
      break;
    case Actions.SET_CONFIGURATIONS_VIEW_MODE:
      state = {
        ...state,
        configurationsViewMode: action.payload,
      };
      break;
    case Actions.SET_SELECTED_CONFIGURATION_IDS:
      state = {
        ...state,
        selectedConfigurationIds: action.payload,
      };
      break;
    case Actions.SET_CURRENT_REQUESTS:
      state = {
        ...state,
        currentRequests: action.payload,
      };
      break;
    case Actions.SET_DRAFTS:
      state = {
        ...state,
        drafts: action.payload || null,
      };
      break;
    case Actions.SET_VALIDATION_RESULTS:
      state = {
        ...state,
        validationResults: action.payload || {},
      };
      break;
    case Actions.SET_SELECTED_REQUEST_IDS:
      state = {
        ...state,
        selectedRequestIds: action.payload,
      };
      break;
    case Actions.SET_CONFIGURATIONS_DATA:
      state = {
        ...state,
        configurationsData: action.payload,
      };
      break;
    case Actions.SET_PREVIOUSLY_SELECTED_PARAMETERS:
      state = {
        ...state,
        previouslySelectedParameters: action.payload,
      };
      break;
    case Actions.SET_CONFIGURATION_ERROR:
      state = {
        ...state,
        configurationError: action.payload,
      };
      break;
    default:
      break;
  }
  if (!isProdEnvironment()) {
    (wnd as any).state = state;
  }
  return state;
};
